import "./lib/diagnostics/installEarly";
import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initAppUpdater } from "./lib/appUpdater";

// Garante que todos os clientes (desktop, mobile, PWA instalado, dispositivos/PDV)
// estejam sempre com a versão mais recente do sistema.
initAppUpdater();


// Admin: força novo login a cada vez que o navegador é fechado.
// Detecta a primeira carga da janela do navegador (sessionStorage não persiste entre janelas/fechamentos)
// e remove o token do Supabase do localStorage para invalidar a sessão antiga.
try {
  const host = window.location.hostname;
  const isAdminApp = host.startsWith("painel.") || host.includes("lovable") || host === "localhost";
  if (isAdminApp) {
    const SESSION_FLAG = "miahma-admin-session-active";
    const KEEP_SESSION_FLAG = "miahma-keep-session"; // CEO opt-in
    const keepSession = localStorage.getItem(KEEP_SESSION_FLAG) === "1";
    if (!sessionStorage.getItem(SESSION_FLAG)) {
      if (!keepSession) {
        // Janela recém-aberta: limpa qualquer token Supabase persistido
        Object.keys(localStorage)
          .filter((k) => k.startsWith("sb-") && k.endsWith("-auth-token"))
          .forEach((k) => localStorage.removeItem(k));
        // Limpa também login de terminal/caixa (dispositivo) para evitar auto-login
        localStorage.removeItem("miahma-device-terminal");
        localStorage.removeItem("miahma-device-employee");
      }
      sessionStorage.setItem(SESSION_FLAG, "1");
    }
  }
} catch {
  // ignore
}

// Minimal loading fallback - just empty screen for instant perception
const LoadingFallback = () => (
  <div className="min-h-screen bg-background" />
);

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Suspense fallback={<LoadingFallback />}>
      <App />
    </Suspense>
  </React.StrictMode>
);
